import { Phone } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

export function Contact() {
  return (
    <section className="mx-auto max-w-7xl px-6 py-20">
      <div className="max-w-xl mx-auto text-center space-y-16">
        <div className="space-y-4">
          <h1 className="font-serif text-5xl text-foreground">Get in Touch</h1>
          <p className="text-lg text-muted-foreground">
            Ready to order or have questions? Reach out via WhatsApp or text.
          </p>
        </div>

        <Card className="bg-card/50 backdrop-blur-sm border-white/5">
          <CardContent className="p-8 space-y-6">
            <a
              href="https://wa.me/18192133065"
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-4 text-foreground hover:text-primary transition-colors group"
            >
              <div className="flex size-12 items-center justify-center rounded-full border border-primary/20 bg-primary/5 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
                <Phone className="size-5" />
              </div>
              <div className="text-left">
                <p className="font-serif text-xl">819-213-3065</p>
                <p className="text-sm text-muted-foreground">
                  WhatsApp or Text Message
                </p>
              </div>
            </a>
          </CardContent>
        </Card>
      </div>
    </section>
  );
}
